angular.module('jv.Common.Directives.Expandy', [])

/*

	jv-expandy
	==========

	Adds basic functionality for a side panel to expand/collapse. Remember to
	import the css in common/_expandy.scss.


	Usage
	-----
	```
	<div jv-expandy>
		<div jv-expandy-panel>
			Content for the collapsable panel
		</div>
		<div jv-expandy-primary>
			Content for the primary section
		</div>
	</div>
	```
 */

.directive('jvExpandy', [function() {
	return {
		templateUrl: '/__assets__/scripts/common/directives/expandy/Expandy.htm',
		scope: {
			expanded: '=?'
		},
		transclude: true,
		controller: function($element, $transclude) {
			$transclude(function(clone) {
				var panel = $element.find('.expandy-panel'),
					primary = $element.find('.expandy-primary');

				panel.append(
					clone.filter('[jv-expandy-panel]').addClass('expandy-panel-inner')
				);
				primary.append(clone.filter('[jv-expandy-primary]'));
			});
		},
		link: function(scope, element, attrs) {
			var primary = element.find('.expandy-primary');
			if (angular.isUndefined(scope.expanded)) {
				scope.expanded = true;
			}

			scope.$watch('expanded', function(expanded) {
				primary.toggleClass('expandy-primary-collapsed', !expanded);
				scope.$emit('expanded', expanded);
			});
		}
	};
}]);